import React from 'react';
import { graphql } from 'react-apollo';
import { CreateSensorMutation } from '../mutations'

//TODO: finish state binding logic, validation
export class CreateSensorComponent extends React.Component {
    constructor(props){
        super(props);
        this.form = {
            name: "",
            room: "",
            lightsOnHighTemp: 80.00,
            lightsOnLowTemp: 70.00,
            lightsOffHighTemp: 75.00,
            lightsOffLowTemp: 65.00,
            tempTransitionPeriodLength: "5m",
            luxLightsOnTarget: 1000,
            luxLightsOffTarget: 200,
            luxThreshold: 200,
            lightsOn: "06:00:00",
            lightsOff: "12:00:00",
        }

        this.state = {
            sending: false,
            error: null,
            form:{
                ...this.form
            }
          };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        console.log("CreateSensorComponent",{props:this.props});
    }

    handleInputChange(event){
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const id = target.id;
        this.setState({
            ...this.state,
            form:{
                ...this.state.form,
                [id]: value
            }
        });
    }

    handleSubmit(event){
        event.preventDefault();
        this.setState({
            ...this.state,
            sending: true,
            error: null
        });


        this.props
        .addSensor({...this.state.form})
        .then(() => {
          this.setState({
            ...this.state,
            sending: false,
            form: {...this.form}
          });
        })
        .catch(error => {
          this.setState({
            ...this.state,
            error,
            sending: false,
          });
        });

        console.log("CreateSensorComponenet::handleSubmit",{ state:this.state, event });
    }

    render() {
        const { error, sending } = this.state;
        console.log("CreateSensorComponenet::render",{state:this.state})

        var submitButton = sending ?  <button className="btn btn-primary disabled mt-3">Sending...</button> : <button type="submit" className="btn btn-primary mt-3">Submit</button>;
        
        return (
          <div>
            {error && <p>{error}</p>}
            <form onSubmit={this.handleSubmit}>
                <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input type="text" className="form-control" id="name" aria-describedby="nameHelp" value={this.state.form.name} onChange={this.handleInputChange} placeholder="optional name or label for sensor"/>
                    <small id="nameHelp" className="form-text text-muted">Name for your sensor.</small>
                </div>
                <div className="form-group">
                    <label htmlFor="room">Room</label>
                    <input type="text" className="form-control" id="room" aria-describedby="roomHelp" value={this.state.form.room} onChange={this.handleInputChange} placeholder="optional room or location for sensor"/>
                    <small id="roomHelp" className="form-text text-muted">The room label for your sensor.</small>
                </div>
                <div className="form-group">
                    <label htmlFor="lightsOnHighTemp">Lights On High Temp</label>
                    <input type="number" className="form-control" id="lightsOnHighTemp" aria-describedby="lightsOnHighTempHelp" value={this.state.form.lightsOnHighTemp} onChange={this.handleInputChange} />
                    <small id="lightsOnHighTempHelp" className="form-text text-muted">The highest temperature allowed when the lights are on.</small>
                </div>
                <div className="form-group">
                    <label htmlFor="lightsOnLowTemp">Lights On Low Temp</label>
                    <input type="number" className="form-control" id="lightsOnLowTemp" aria-describedby="lightsOnLowTempHelp" value={this.state.form.lightsOnLowTemp} onChange={this.handleInputChange} />
                    <small id="lightsOnLowTempHelp" className="form-text text-muted">The lowest temperature allowed when the lights are on.</small>
                </div>
                <div className="form-group">
                    <label htmlFor="lightsOffHighTemp">Lights Off High Temp</label>
                    <input type="number" className="form-control" id="lightsOffHighTemp" aria-describedby="lightsOffHighTempHelp" value={this.state.form.lightsOffHighTemp} onChange={this.handleInputChange} />
                    <small id="lightsOffHighTempHelp" className="form-text text-muted">The highest temperature allowed when the lights are off.</small>
                </div>
                <div className="form-group">
                    <label htmlFor="lightsOffLowTemp">Lights Off Low Temp</label>
                    <input type="number" className="form-control" id="lightsOffLowTemp" aria-describedby="lightsOffLowTempHelp" value={this.state.form.lightsOffLowTemp} onChange={this.handleInputChange} />
                    <small id="lightsOffLowTempHelp" className="form-text text-muted">The lowest temperature allowed when the lights are off.</small>
                </div>
                <div className="form-group">
                    <label htmlFor="tempTransitionPeriodLength">Temp Transition Period Length</label>
                    <input type="text" className="form-control" id="tempTransitionPeriodLength" aria-describedby="tempTransitionPeriodLengthHelp" value={this.state.form.tempTransitionPeriodLength} onChange={this.handleInputChange} />
                    <small id="tempTransitionPeriodLengthHelp" className="form-text text-muted">The period of time in which the temperature is allowed to be between the Highest and lowest allowed values.</small>
                </div>
                <div className="form-group">
                    <label htmlFor="luxLightsOnTarget">Lux Lights On Target</label>
                    <input type="number" className="form-control" id="luxLightsOnTarget" aria-describedby="luxLightsOnTargetHelp" value={this.state.form.luxLightsOnTarget} onChange={this.handleInputChange} />
                    <small id="luxLightsOnTargetHelp" className="form-text text-muted">Target reading for when the lights are considered to be on.</small>
                </div>
                <div className="form-group">
                    <label htmlFor="luxLightsOffTarget">Lux Lights Off Target</label>
                    <input type="number" className="form-control" id="luxLightsOffTarget" aria-describedby="luxLightsOffTargetHelp" value={this.state.form.luxLightsOffTarget} onChange={this.handleInputChange} />
                    <small id="luxLightsOffTargetHelp" className="form-text text-muted">Target reading for when the lights are considered to be on.</small>
                </div>
                <div className="form-group">
                    <label htmlFor="luxThreshold">Lux Threshold</label>
                    <input type="number" className="form-control" id="luxThreshold" aria-describedby="luxThresholdHelp" value={this.state.form.luxThreshold} onChange={this.handleInputChange} />
                    <small id="luxThresholdHelp" className="form-text text-muted">Variance allowed for lux readings.</small>
                </div>
                <div className="form-group">
                    <label htmlFor="lightsOn">Lights On</label>
                    <input type="text" className="form-control" id="lightsOn" aria-describedby="lightsOnHelp" value={this.state.form.lightsOn} onChange={this.handleInputChange} />
                    <small id="lightsOnHelp" className="form-text text-muted">Time when the lights turn on 24h format.</small>
                </div>
                <div className="form-group">
                    <label htmlFor="lightsOff">Lights Off</label>
                    <input type="text" className="form-control" id="lightsOff" aria-describedby="lightsOffHelp" value={this.state.form.lightsOff} onChange={this.handleInputChange} />
                    <small id="lightsOffHelp" className="form-text text-muted">Time when the lights turn off 24h format.</small>
                </div>
                {submitButton}
            </form>
          </div>
        );
    }
}

export default graphql(CreateSensorMutation, {
  props: ({mutate}) =>({
    addSensor: sensor =>  mutate({
        variables:{
            ...sensor
        },
        optimisticResponse: () => ({
            createSensor: {
                ...sensor
            }
        }),
        update: (proxy, arg) => {
           console.log("update", { proxy:proxy, arg: arg });
        }
    })
  }),
})(CreateSensorComponent);


// WEBPACK FOOTER //
// ./src/routes/CreateSensor.js